export const cmsAutocompleteEnterSelectProps = {
    autoHighlight: true,
    handleHomeEndKeys: true,
} as const;
